import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconScan$1 = /*@__PURE__*/ proxyCustomElement(class WppIconScan extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-scan", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M6.25 3C4.45507 3 3 4.45507 3 6.25V7.59615C3 8.01037 3.33579 8.34615 3.75 8.34615C4.16421 8.34615 4.5 8.01037 4.5 7.59615V6.25C4.5 5.2835 5.2835 4.5 6.25 4.5H7.59615C8.01037 4.5 8.34615 4.16421 8.34615 3.75C8.34615 3.33579 8.01037 3 7.59615 3H6.25ZM12.4038 3C11.9896 3 11.6538 3.33579 11.6538 3.75C11.6538 4.16421 11.9896 4.5 12.4038 4.5H13.75C14.7165 4.5 15.5 5.2835 15.5 6.25V7.59615C15.5 8.01037 15.8358 8.34615 16.25 8.34615C16.6642 8.34615 17 8.01037 17 7.59615V6.25C17 4.45507 15.5449 3 13.75 3H12.4038ZM4.5 12.4038C4.5 11.9896 4.16421 11.6538 3.75 11.6538C3.33579 11.6538 3 11.9896 3 12.4038V13.75C3 15.5449 4.45507 17 6.25 17H7.59615C8.01037 17 8.34615 16.6642 8.34615 16.25C8.34615 15.8358 8.01037 15.5 7.59615 15.5H6.25C5.2835 15.5 4.5 14.7165 4.5 13.75V12.4038ZM17 12.4038C17 11.9896 16.6642 11.6538 16.25 11.6538C15.8358 11.6538 15.5 11.9896 15.5 12.4038V13.75C15.5 14.7165 14.7165 15.5 13.75 15.5H12.4038C11.9896 15.5 11.6538 15.8358 11.6538 16.25C11.6538 16.6642 11.9896 17 12.4038 17H13.75C15.5449 17 17 15.5449 17 13.75V12.4038ZM6.75 9.25C6.33579 9.25 6 9.58579 6 10C6 10.4142 6.33579 10.75 6.75 10.75H13.25C13.6642 10.75 14 10.4142 14 10C14 9.58579 13.6642 9.25 13.25 9.25H6.75Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-scan-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-scan", "wpp-icon-scan-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-scan-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-scan-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconScan$1);
      }
      break;
  } });
}

const WppIconScan = WppIconScan$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconScan, defineCustomElement };
